export default __webpack_public_path__ + "static/B0050-80e80934220474877700d95061c199c3.png";